<app-breadcrumb  [master]="'Analizy'" [parentName]="'Raporty'" [name]="'Lista'"></app-breadcrumb>
<div class="report-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-list-filters">
<!--    <mat-form-field class="report-list-filter">-->
<!--      <mat-label>Nazwa</mat-label>-->
<!--      <input matInput placeholder="Nazwa" name="contains$newsletterName" [(ngModel)]="initialFilters.contains$newsletterName">-->
<!--    </mat-form-field>-->

  </form>

<!--  <div class="report-list-buttons">-->
<!--    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
<!--    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
<!--  </div>-->

  <table mat-table [dataSource]="reportFiles">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nazwa pliku</th>
      <td mat-cell *matCellDef="let element">
        {{element.fileName }}
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="ic">
      <th mat-header-cell *matHeaderCellDef> TU</th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">
          <mat-icon>download</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
